module.exports = __webpack_public_path__ + "res/ic_share.36994c4c2abe0fd80462def891029765.png";